import React from "react";
import { axiosget } from "../../helpers/httprequest";
import { useQuery } from "@tanstack/react-query";
import ReactModal from "react-modal";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import ApplicationForm from "./ApplicationForm";

const StartNewApplication = ({ v }) => {
  const [showmodal, setshowmodal] = React.useState(false);
  const { data, isLoading, error } = useQuery({
    queryKey: ["startApplicationCheck"],
    queryFn: async () => {
      const req = await axiosget(`ms_dashboard`);
      return req?.data;
    },
    enabled: !!showmodal,
  });
  const _close = () => {
    setshowmodal(false);
  };
  let err = 0;
  if (data !== undefined) {
    if (data?.ref < 2) {
      err = 1;
    }
    if (data?.bio < 1) {
      err = 1;
    }
    if (data?.olevel < 1) {
      err = 1;
    }
    if (data?.result < 5) {
      err = 1;
    }
  }
  return (
    <>
      <ReactModal isOpen={showmodal} onRequestClose={_close} className="ReactModal">
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-uppercase text-center">Manage This Application </h5>
              <span className="pointer text-danger" onClick={_close}>
                x
              </span>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  {isLoading && <Loader />}
                  {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
                  {data?.type !== undefined && <ErrorResponse type={`danger`} message={`${data?.message}`} />}
                  {!isLoading && err === 1 && (
                    <>
                      {data?.type === undefined && data?.ref < 2 && (
                        <ErrorResponse type={`danger`} message={`You are required to upload 2 referees/guardians`} />
                      )}
                      {data?.type === undefined && data?.bio < 1 && <ErrorResponse type={`danger`} message={`You need to upload your bio data`} />}
                      {data?.type === undefined && data?.olevel < 1 && (
                        <ErrorResponse type={`danger`} message={`Please check your O-Level sittings  maximum sittings is 2 `} />
                      )}
                      {data?.type === undefined && data?.result < 5 && (
                        <ErrorResponse
                          type={`danger`}
                          message={`Please check your O-Level results add a minimum of 6 results, ${data?.result} currently added`}
                        />
                      )}
                    </>
                  )}

                  {data !== undefined && err === 0 && <ApplicationForm v={v} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
      <button disabled={!v.verified ? true : false} className="btn btn-primary float-right" onClick={() => setshowmodal(true)}>
        Continue Application <i className="fa-solid fa-right-long"></i>
      </button>
    </>
  );
};

export default StartNewApplication;
